import { Tooltip, Box } from '@mui/material';

interface GridCellTooltipProps {
  value: string;
  maxWidth?: number | string;
}

/** Truncates long grid cell text and shows the full value on hover. */
export default function GridCellTooltip({ value, maxWidth = '100%' }: GridCellTooltipProps) {
  const text = value?.trim() || '-';
  if (text === '-' || text === '—' || text === 'N/A') {
    return (
      <Box
        component="span"
        sx={{
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth,
          color: 'text.secondary',
          fontSize: '0.75rem',
        }}
      >
        {text}
      </Box>
    );
  }
  return (
    <Tooltip title={text} arrow placement="top-start" enterDelay={200}>
      <Box
        component="span"
        sx={{
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth,
          color: 'text.secondary',
          fontSize: '0.8125rem',
          cursor: 'help',
        }}
      >
        {text}
      </Box>
    </Tooltip>
  );
}
